const BaseUrl = 'https://api.v1.fpay.az';
export default BaseUrl;